import { Avatar, Skeleton, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { PoweredBySection } from 'components/WhiteLabelling';
import { useAppSelector } from "../../../redux/store";
import { selectContractorId } from "../../../redux/slices/reportSlice/report";
import { useGetContractorDetailsQuery } from "../../../gql/generated/queries";

const ReportDrawerFooter = () => {
  const contractorId = useAppSelector(selectContractorId);
  const { data, isLoading } = useGetContractorDetailsQuery({ contractorId }, { skip: !contractorId });

  if (isLoading && !data) {
    return <ReportDrawerSkeleton />;
  } else if (!isLoading && !data?.contractor) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 2,
        borderTop: '1px solid',
        borderTopColor: 'divider',
      }}
    >
      <Stack sx={{ marginBottom: 3 }}>
        <PoweredBySection />
      </Stack>
      <Stack spacing={2} direction="row">
        <Avatar
          alt={data?.contractor?.businessName || 'contractor logo'}
          src={data?.contractor?.logo?.url}
          sx={{ width: 64, height: 64 }}
        />
        <Stack>
          <Typography variant="caption">
            Inspected by &nbsp;
          </Typography>
          <Typography
            fontWeight="bold"
            pb={2}
          >
            {data?.contractor?.businessName}
          </Typography>

          {data?.contractor?.stateLicenseNumber && (
            <Typography variant="caption">
              State License # {data?.contractor?.stateLicenseNumber}
            </Typography>
          )}
          {data?.contractor?.ashiLicenseNumber && (
            <Typography variant="caption">
              ASHI License # {data?.contractor?.ashiLicenseNumber}
            </Typography>
          )}
          {data?.contractor?.internachiLicenseNumber && (
            <Typography variant="caption">
              InterNACHI License # {data?.contractor?.internachiLicenseNumber}
            </Typography>
          )}
          {data?.contractor?.otherLicenseNumber && (
            <Typography variant="caption">
              Other License # {data?.contractor?.otherLicenseNumber}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default ReportDrawerFooter;

const ReportDrawerSkeleton = () => (
  <Box sx={{ p: 2, width: '100%' }}>
    <Stack direction="row" height={38} spacing={2}>
      <Skeleton variant="circular" width={48} height={38} />
      <Skeleton variant="text" width="100%" height={38} />
    </Stack>
    <Skeleton variant="text" width="100%" />
    <Skeleton variant="text" width="100%" />
  </Box>
)
